export class AircraftModel {
    public aircraftId?: number;
    public aircraftTypeId: number;
    public aircraftModelId: number;
    public modelYear: number;
    public airportId: number;
    public aircraftStorageLocationTypeId: number;
    public faaNumber: string;
    public serialNumber: string;
    public aircraftStatusTypeId: number;
}
